<template>
  <div>
    <input type="text"
           class="form-control"
           v-model="inputValue"
           v-debounce="userTyped"
           debounce-events='keydown'
    placeholder="Team/Trainer suchen">
    <div v-if="!selectedItem" id="teamAndCoachSearchSuggestions">
      <div class="list-group">
        <div class="list-group-item p-1 text-start link"
             v-for="suggestion in suggestions"
             :key="suggestion.key"
             @click="selectedItem = suggestion">
          <team-emblem size="21" class="img-fluid" :emblem-id="suggestion.emblemId"/>
          <span class="ps-1 align-middle">{{ suggestion.name }}</span>
          <span class="text-secondary">
            - <sakali-user :user="suggestion.coach"
                           :show-avatar="true"/>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      inputValue: '',
      suggestions: [],
      selectedItem: undefined
    }
  },
  methods: {
    async userTyped() {
      this.selectedItem = undefined
      this.$api.get('/search/teams-and-coaches', {
        params: {
          q: this.inputValue
        }
      }).then(result =>
          this.suggestions = result.data
      ).catch(error => this.handleError(error))
    }
  },
  watch: {
    selectedItem() {
      if (this.selectedItem) {
        // this.inputValue = this.selectedItem.name + ' - ' + this.selectedItem.coach.name
        this.$emit('input', this.selectedItem)
        this.inputValue = ''
      }
    }
  }
}
</script>

<style>
#teamAndCoachSearchSuggestions {
  position: absolute;
  z-index: 999;
  right: 4em;
  min-width: 200px;
}
</style>